import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import ConfirmButton from "./ConfirmButton";
import SlideUpTransition from "./SlideUpTransition";

const SuccessDialog = (props) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "500px",
          maxWidth: "90vw",
          margin: "auto",
          whiteSpace: "pre-line",
        },
      }}
      open={props.isSuccessDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      data-testid="success-dialog"
    >
      <DialogTitle id="alert-dialog-slide-title" style={{ paddingBottom: "0px" }}>
        {props.title}
      </DialogTitle>

      <DialogContent>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            {props.subTitle && (
              <Grid item xs={12}>
                {props.subTitle}
              </Grid>
            )}
          </Grid>
        </DialogContentText>
      </DialogContent>

      <DialogContent>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12}>
              {props.hasError ? (
                <Alert severity="error">{props.error}</Alert>
              ) : props.message.__html ? (
                <Alert severity={"success"}>
                  <span dangerouslySetInnerHTML={props.message} />
                </Alert>
              ) : (
                <Alert severity={"success"}>{props.message}</Alert>
              )}
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        {props.redirectTo ? (
          <Link to={props.redirectTo} className="link">
          <ConfirmButton variant="contained" color="primary" onClick={props.handleOKClick}>
            Ok
          </ConfirmButton>
        </Link>
        ) : (
          <ConfirmButton variant="contained" color="primary" onClick={props.handleOKClick}>
            Ok
          </ConfirmButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

SuccessDialog.propTypes = {
  isSuccessDialogOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  redirectTo: PropTypes.string,
  handleOKClick: PropTypes.func,
  hasError: PropTypes.bool,
  error: PropTypes.string,
};

export default SuccessDialog;
